import * as R from 'ramda'
import { compose, mapProps, withState, withHandlers } from 'recompose'

import { displayError } from 'helpers/validator'

// Validates a single valueobject, state should only hold the errors
/*const HocValidates = (validationRules) => compose(
  mapProps(({ values, ...rest }) => ({
    errors: R.map(displayError, getErrors(values, validationRules)),
    ...rest,
  }))
)
*/

const HocValidate = (validationRules) => mapProps(({ value, ...rest }) => {
  return ({
  error: displayError(value, validationRules),
  value,
  ...rest,
})})

export {
  HocValidate,
}
